import React from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { mockContactInfo } from '../utils/mock';

export const ContactSection = ({ openPopup }) => {
  return (
    <section id="contact" className="py-20 bg-[#FFF7ED]">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#7C2D12] mb-4">
              Contact Us
            </h2>
            <p className="text-xl text-gray-600">
              Ready to protect your brand? Get in touch with our trademark experts today.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Contact Information */}
            <div className="space-y-6">
              <Card className="p-8 bg-white border-2 border-[#FED7AA]">
                <h3 className="text-2xl font-bold text-[#7C2D12] mb-6">
                  Get In Touch
                </h3>
                
                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="bg-[#F97316] p-3 rounded-lg mr-4">
                      <Phone className="text-white" size={24} />
                    </div>
                    <div>
                      <div className="font-semibold text-[#7C2D12] mb-1">Phone</div>
                      <a 
                        href={`tel:${mockContactInfo.phone.replace(/\s/g, '')}`}
                        className="text-gray-600 hover:text-[#F97316] transition-colors"
                      >
                        {mockContactInfo.phone}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="bg-[#F97316] p-3 rounded-lg mr-4">
                      <Mail className="text-white" size={24} />
                    </div>
                    <div>
                      <div className="font-semibold text-[#7C2D12] mb-1">Email</div>
                      <a 
                        href={`mailto:${mockContactInfo.email}`}
                        className="text-gray-600 hover:text-[#F97316] transition-colors"
                      >
                        {mockContactInfo.email}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="bg-[#F97316] p-3 rounded-lg mr-4">
                      <MapPin className="text-white" size={24} />
                    </div>
                    <div>
                      <div className="font-semibold text-[#7C2D12] mb-1">Address</div>
                      <p className="text-gray-600">
                        {mockContactInfo.address}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="bg-[#F97316] p-3 rounded-lg mr-4">
                      <Clock className="text-white" size={24} />
                    </div>
                    <div>
                      <div className="font-semibold text-[#7C2D12] mb-1">Business Hours</div>
                      <p className="text-gray-600">
                        Monday - Friday: 9:00 AM - 6:00 PM EST<br />
                        Saturday: 10:00 AM - 4:00 PM EST<br />
                        Sunday: Closed
                      </p>
                    </div>
                  </div>
                </div>
              </Card>
            </div>

            {/* CTA Card */}
            <div className="space-y-6">
              <Card className="p-8 bg-gradient-to-br from-[#7C2D12] to-[#F97316] border-0 text-white h-full flex flex-col justify-center">
                <h3 className="text-3xl font-bold mb-6">
                  Ready to Protect Your Brand?
                </h3>
                <p className="text-white/95 text-lg mb-4 leading-relaxed">
                  Our trademark experts are standing by to help you protect your most valuable business asset—your brand identity. Whether you're just starting out and need guidance on mark selection, ready to file your application, or dealing with a complex office action, we have the experience and expertise to help.
                </p>
                <p className="text-white/95 text-lg mb-6 leading-relaxed">
                  Click below to schedule your free consultation where we'll discuss your trademark needs, evaluate your mark's registrability, explain the process, and provide transparent pricing options. Or start your application immediately—most applications are filed within 24-48 hours. Either way, you'll work with a dedicated case manager who guides you through every step.
                </p>
                
                <div className="space-y-4">
                  <Button 
                    onClick={openPopup}
                    size="lg"
                    className="w-full bg-white text-[#7C2D12] hover:bg-[#FED7AA] py-6 text-lg font-bold transition-all duration-300"
                  >
                    Start Your Application
                  </Button>
                  
                  <Button 
                    onClick={openPopup}
                    size="lg"
                    variant="outline"
                    className="w-full bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white hover:text-[#7C2D12] py-6 text-lg font-bold transition-all duration-300"
                  >
                    Schedule Free Consultation
                  </Button>
                </div>

                <div className="mt-8 pt-8 border-t border-white/20">
                  <p className="text-white/90 text-sm mb-2">
                    <strong>Need immediate assistance?</strong> Call us now for a free consultation:
                  </p>
                  <a href={`tel:${mockContactInfo.phone.replace(/\s/g, '')}`} className="text-2xl font-bold hover:underline block">
                    {mockContactInfo.phone}
                  </a>
                  <p className="text-white/80 text-sm mt-2">
                    Available Monday-Friday 9AM-6PM EST, Saturday 10AM-4PM EST
                  </p>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
